import { createFetchResponseError, handleFetchError } from './fetch-error-handling';
import { ArticleData } from '../types';

export interface AddResponse {
    added: boolean;
    logged: boolean;
}

export class BackendAjaxAdapter {

    public async addBookmark(articleData : ArticleData, magicLink: string): Promise<AddResponse> {
        const apiUrl = magicLink + 'api/bookmark/';
        const requestUrl = `${apiUrl}bookmark-add?salesArticleVariantKey=${articleData.savKey}`;

        try {
            const response = await fetch(requestUrl, { method: 'POST' });

            if (!response.ok) {
                const error = await createFetchResponseError(response);
                const responseBody = error.responseBody as Partial<AddResponse> | null;
                const logged = responseBody?.logged === true;
                handleFetchError(error, !logged, apiUrl);
                return { added: false, logged };
            }

            return await response.json() as AddResponse;
        } catch (error) {
            const fetchError = error instanceof Error ? error : new Error(String(error));
            handleFetchError(fetchError, true, apiUrl);
            return { added: false, logged: false };
        }
    }
}
